<div class="flex flex-col gap-3">
  @for (row of rows().controls; track row; let i = $index) {
    <div class="grid grid-cols-1 sm:grid-cols-[minmax(0,2fr)_9rem_minmax(0,3fr)_auto] gap-3 items-start" [formGroup]="row">
      <div class="flex flex-col gap-1">
        <p-floatlabel class="w-full" variant="on">
          <input pInputText [id]="idPrefix() + '-key-' + i" formControlName="key" maxlength="40" class="w-full"
            [invalid]="!!keyError(row, i)" autocomplete="off" />
          <label [for]="idPrefix() + '-key-' + i">Llave *</label>
        </p-floatlabel>
        @if (keyError(row, i); as error) {
          <small class="text-red-600">{{ error }}</small>
        }
      </div>
      <p-floatlabel class="w-full" variant="on">
        <p-select [inputId]="idPrefix() + '-type-' + i" formControlName="type" [options]="types" optionLabel="label"
          optionValue="value" class="w-full" appendTo="body" />
        <label [for]="idPrefix() + '-type-' + i">Tipo</label>
      </p-floatlabel>
      <div class="flex flex-col gap-1">
        <p-floatlabel class="w-full" variant="on">
          <input pInputText [id]="idPrefix() + '-value-' + i" formControlName="value" class="w-full"
            [attr.maxlength]="isNumber(row) ? 11 : 500" [attr.inputmode]="isNumber(row) ? 'numeric' : null"
            [class.text-right]="isNumber(row)" [invalid]="!!valueError(row)" autocomplete="off" />
          <label [for]="idPrefix() + '-value-' + i">Valor *</label>
        </p-floatlabel>
        @if (valueError(row); as error) {
          <small class="text-red-600">{{ error }}</small>
        }
      </div>
      <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" type="button" ariaLabel="Quitar dato"
        (onClick)="remove(i)" />
    </div>
  } @empty {
    <p class="text-sm text-slate-500 m-0">Sin metadata comercial.</p>
  }
  <div class="flex items-center justify-between gap-3">
    <small class="text-slate-500">{{ rows().length }} de {{ maxKeys }} datos.</small>
    <p-button label="Agregar dato" icon="pi pi-plus" size="small" type="button" [outlined]="true"
      [disabled]="rows().length >= maxKeys" (onClick)="add()" />
  </div>
</div>
